import Wording from './Wording'

export default Wording